/*LocaleMapper util - duplicated from resource-js because it is needed to send the full locale in the axios config - no access to props*/
const defaultLocales = {
    ar: 'ar-AR',
    bg: 'bg-BG',
    pt: 'pt-PT',
    pt_BR: 'pt-BR',
    pl: 'pl-PL',
    no: 'nb-NO',
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    es: 'es-ES',
    et: 'et-EE',
    fr: 'fr-FR',
    hr: 'hr-HR',
    it: 'it-IT',
    iw: 'iw-IL',
    hu: 'hu-HU',
    lv: 'lv-LV',
    lt: 'lt-LT',
    nl: 'nl-NL',
    nb: 'nb-NO',
    sl: 'sl-SI',
    sk: 'sk-SK',
    fi: 'fi-FI',
    sv: 'sv-SE',
    en: 'en-US',
    el: 'el-GR',
    ru: 'ru-RU',
    ro: 'ro-RO',
    ja: 'ja-JP',
    ko: 'ko-KR',
    th: 'th-TH',
    vi: 'vi-VN',
    tr: 'tr-TR',
    in: 'in-ID',
    ms: 'ms-MY',
    zh_CN: 'zh-CN',
    zh_TW: 'zh-TW'
};

export const getFullLocale = (locale) => {
    let fullLocale = defaultLocales[locale];
    if (typeof fullLocale === 'undefined') {
        fullLocale = 'en-US';
    }
    return fullLocale;
};

export const getShortLocale = (locale) => {
    let shortLocale = defaultLocales[locale];

    if (typeof shortLocale === 'undefined') {
        shortLocale = 'en';
    }

    // Shorten the locale to two characters
    shortLocale = shortLocale.substr(0, 2);

    return shortLocale;
};

export const isTranslationForLocalAvailable = (locale) => {
    return locale && locale !== 'et' && locale !== 'lt' && locale !== 'lv' && locale !== 'bg';
};
